import { createSlice } from '@reduxjs/toolkit';
import initialState from './queryBuilderInitialState';
import {
  _addField,
  _updateField,
  _removeField,
  _reorderFields,
  _clearFields,
  _setGeneratedSql,
  _setLoading,
  _setExecuting,
  _setQueryResults,
  _setError,
  _setSuccessMessage,
  _clearError,
  _clearSuccessMessage,
  _resetQueryBuilder,
  _loadSavedQueries,
  _loadQuery,
  _updateSavedQueries,
  _setCurrentQueryId,
  _setHasUnsavedChanges
} from './queryBuilderActions';

const queryBuilderSlice = createSlice({
  name: 'stop/queryBuilder',
  initialState,
  reducers: {
    addField: _addField,
    updateField: _updateField,
    removeField: _removeField,
    reorderFields: _reorderFields,
    clearFields: _clearFields,
    setGeneratedSql: _setGeneratedSql,
    setLoading: _setLoading,
    setExecuting: _setExecuting,
    setQueryResults: _setQueryResults,
    setError: _setError,
    setSuccessMessage: _setSuccessMessage,
    clearError: _clearError,
    clearSuccessMessage: _clearSuccessMessage,
    resetQueryBuilder: _resetQueryBuilder,
    loadSavedQueries: _loadSavedQueries,
    loadQuery: _loadQuery,
    updateSavedQueries: _updateSavedQueries,
    setCurrentQueryId: _setCurrentQueryId,
    setHasUnsavedChanges: _setHasUnsavedChanges
  }
});

export const {
  addField,
  updateField,
  removeField,
  reorderFields,
  clearFields,
  setGeneratedSql,
  setLoading,
  setExecuting,
  setQueryResults,
  setError,
  setSuccessMessage,
  clearError,
  clearSuccessMessage,
  resetQueryBuilder,
  loadSavedQueries,
  loadQuery,
  updateSavedQueries,
  setCurrentQueryId,
  setHasUnsavedChanges
} = queryBuilderSlice.actions;

export default queryBuilderSlice.reducer;
